// src/constants/apiBases.ts
// Single source of truth for the backend base URL. The calculator gateway
// (wing-insurers-api) serves /aggregator and proxies every insurer
// integration under /ozk, /dzi, /generali, /l-ins, /dall-bogg.

export const CALCULATOR_BASE_URL =
  // @ts-ignore
  import.meta.env.VITE_CALCULATOR_API_URL ?? "https://sys.librains.com:4000";
